var React = require('react');

function YellowTriangle (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M18.2103 0.500061L28.7087 26.9776L0.529297 22.8308L18.2103 0.500061Z","fill":"#FFE01A","key":0}),React.createElement("path",{"d":"M28.7087 26.9776L0.529297 22.8308L5.83957 16.124L28.7087 26.9776Z","fill":"#FCBD00","key":1})]);
}

YellowTriangle.defaultProps = {"width":"29","height":"27","viewBox":"0 0 29 27","fill":"none"};

module.exports = YellowTriangle;

YellowTriangle.default = YellowTriangle;
